import { gql } from '@apollo/client';

export const DELETE_ACCESS_GROUP_V2 = gql`
  mutation DeleteAccessGroupv2($input: DeleteAccessGroupInputv2!) {
    deleteAccessGroupv2(input: $input) {
      message
      item
      isSuccess
    }
  }
`;
